import React from "react";
import { useParams } from "react-router-dom";
import usePromise from "hooks/promises/usePromise";
import PromiseView from "components/promises/PromiseView";
import Loading from "components/common/Loading";

const PromisePage = ({ isEditable }) => {
  const { id } = useParams();
  const { current, isLoading } = usePromise({ id });
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <PromiseView promise={current} isEditable={isEditable} />
      )}
    </div>
  );
};

export default PromisePage;
